// 20.2.2.33 Math.tanh(x)
var $export = require('./_export')
  , expm1   = require('./_math-expm1')
  , exp     = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x){
    var a = expm1(x = +x)
      , b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/babel-polyfill/~/core-js/modules/es6.math.tanh.js
// module id = 120
// module chunks = 0